/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Response } from '../models/response';
import { ResetPasswordRequest } from '../models/reset-password-request';
import { SavePasswordResetPasswordRequest } from '../models/save-password-reset-password-request';
import { TokenValidity } from '../models/token-validity';
import { TokenValidationRequest } from '../models/token-validation-request';

/**
 * Ui No Auth User Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiNoAuthUserControllerService extends __BaseService {
  static readonly resetPasswordRequestUsingPOSTPath =
    '/public-ui/v1/user/resetPassword';
  static readonly savePasswordUsingPOSTPath = '/public-ui/v1/user/savePassword';
  static readonly validateTokenUsingPOSTPath =
    '/public-ui/v1/user/token/validate';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * resetPasswordRequest
   * @param resetPasswordRequest resetPasswordRequest
   * @return OK
   */
  resetPasswordRequestUsingPOSTResponse(
    resetPasswordRequest: ResetPasswordRequest,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = resetPasswordRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public-ui/v1/user/resetPassword`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * resetPasswordRequest
   * @param resetPasswordRequest resetPasswordRequest
   * @return OK
   */
  resetPasswordRequestUsingPOST(
    resetPasswordRequest: ResetPasswordRequest,
  ): __Observable<Response> {
    return this.resetPasswordRequestUsingPOSTResponse(
      resetPasswordRequest,
    ).pipe(__map((_r) => _r.body as Response));
  }

  /**
   * savePassword
   * @param savePasswordResetPasswordRequest savePasswordResetPasswordRequest
   * @return OK
   */
  savePasswordUsingPOSTResponse(
    savePasswordResetPasswordRequest: SavePasswordResetPasswordRequest,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = savePasswordResetPasswordRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public-ui/v1/user/savePassword`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * savePassword
   * @param savePasswordResetPasswordRequest savePasswordResetPasswordRequest
   * @return OK
   */
  savePasswordUsingPOST(
    savePasswordResetPasswordRequest: SavePasswordResetPasswordRequest,
  ): __Observable<Response> {
    return this.savePasswordUsingPOSTResponse(
      savePasswordResetPasswordRequest,
    ).pipe(__map((_r) => _r.body as Response));
  }

  /**
   * validateToken
   * @param validationRequest validationRequest
   * @return OK
   */
  validateTokenUsingPOSTResponse(
    validationRequest: TokenValidationRequest,
  ): __Observable<__StrictHttpResponse<TokenValidity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = validationRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public-ui/v1/user/token/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TokenValidity>;
      }),
    );
  }
  /**
   * validateToken
   * @param validationRequest validationRequest
   * @return OK
   */
  validateTokenUsingPOST(
    validationRequest: TokenValidationRequest,
  ): __Observable<TokenValidity> {
    return this.validateTokenUsingPOSTResponse(validationRequest).pipe(
      __map((_r) => _r.body as TokenValidity),
    );
  }
}

module UiNoAuthUserControllerService {}

export { UiNoAuthUserControllerService };
